/**
 * Utility functions for managing JivoChat widget
 */

declare global {
  interface Window {
    jivo_destroy?: () => void;
    jivo_cstm_widget?: HTMLElement;
  }
}

const JIVO_WIDGET_ID = import.meta.env.JIVO_WIDGET_ID || "fpUbtSpubF";
const JIVO_SCRIPT_ID = "jivo-chat-script";
const JIVO_CUSTOM_SCRIPT_ID = "jivo-custom-widget-script";
const JIVO_CUSTOM_CSS_ID = "jivo-custom-widget-css";

/**
 * Loads the JivoChat widget dynamically.
 * Should be called when user is authenticated and on a brand route.
 * Only Jivo's own launcher is used; its color/appearance is configured in the
 * JivoChat admin panel, not in this codebase.
 */
export function loadJivoChat(): void {
  // Don't load if already loaded
  if (document.getElementById(JIVO_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement("script");
  script.id = JIVO_SCRIPT_ID;
  script.src = `//code.jivosite.com/widget/${JIVO_WIDGET_ID}`;
  script.async = true;
  document.head.appendChild(script);
}

/**
 * Destroys the JivoChat widget.
 * Should be called when user logs out or leaves brand routes.
 */
export function destroyJivoChat(): void {
  // Call jivo_destroy if available
  if (typeof window.jivo_destroy === "function") {
    window.jivo_destroy();
  }

  // Remove the scripts and the custom-skin stylesheet
  for (const id of [JIVO_SCRIPT_ID, JIVO_CUSTOM_SCRIPT_ID, JIVO_CUSTOM_CSS_ID]) {
    document.getElementById(id)?.remove();
  }

  // Remove custom widget if exists
  if (window.jivo_cstm_widget) {
    window.jivo_cstm_widget.remove();
    window.jivo_cstm_widget = undefined;
  }

  // Remove any jivo elements
  const jivoElements = document.querySelectorAll(
    "jdiv, #jivo_custom_widget, #jivo_custom_header"
  );
  jivoElements.forEach((el) => el.remove());
}
